<template>
  <div class="list-table-body">

    <van-list v-model="listLoading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="flex list-table-item" v-for="(item, index) in tableData" :key="index">
        <div class="table-1 flex-1" style="text-align: center;">
          <span>{{ item.userName }}</span>
        </div>
        <div class="table-3 flex" :class="dynamicHeader.length == 1 ? 'flex-2' : 'flex-1'"
          v-for="header in dynamicHeader">
          <template v-if="dynamicHeader.length <= 2">
            <span class="flex-1"
              :class="item[headerTitle[Number(header)].headerStatus] == -1 ? 'late' : item[headerTitle[Number(header)].headerStatus] == -2 ? 'early' : ''">
              {{ item[headerTitle[Number(header)].header] }}
            </span>
            <span class="flex-1"
              :class="item[headerTitle[Number(header)].lastStatus] == -1 ? 'late' : item[headerTitle[Number(header)].lastStatus] == -2 ? 'early' : ''">
              {{ item[headerTitle[Number(header)].last] }}
            </span>
          </template>
          <template v-else>
            <div class="flex-1">
              <template v-if="item.dynamicHeader && item.dynamicHeader.indexOf('0') != -1">
                <div class="tow-merge-one" v-if="item[headerTitle[Number(header)].header]"
                  :class="item[headerTitle[Number(header)].headerStatus] == -1 ? 'late' : item[headerTitle[Number(header)].headerStatus] == -2 ? 'early' : ''">
                  {{ item[headerTitle[Number(header)].header] }}
                </div>
                <div class="tow-merge-one" v-if="item[headerTitle[Number(header)].last]"
                  :class="item[headerTitle[Number(header)].lastStatus] == -1 ? 'late' : item[headerTitle[Number(header)].lastStatus] == -2 ? 'early' : ''">
                  {{ item[headerTitle[Number(header)].last] }}
                </div>
              </template>
              <template v-else>
                <div class="tow-merge-one"
                  :class="item[headerTitle[Number(header)].headerStatus] == -1 ? 'late' : item[headerTitle[Number(header)].headerStatus] == -2 ? 'early' : ''">
                  {{ item[headerTitle[Number(header)].header] }}
                </div>
                <div class="tow-merge-one-line"
                  v-if="item[headerTitle[Number(header)].header] || item[headerTitle[Number(header)].last]">
                  <div class="tow-merge-one-line-inner"></div>
                </div>
                <div class="tow-merge-one"
                  :class="item[headerTitle[Number(header)].lastStatus] == -1 ? 'late' : item[headerTitle[Number(header)].lastStatus] == -2 ? 'early' : ''">
                  {{ item[headerTitle[Number(header)].last] }}
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </van-list>

  </div>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    infoItemClass: {
      type: Number,
    },
    zhiClass:{
      type:Array
    },
    totalPage: {
      type:Number

    },
    date : {
      type: String
    },
    dynamicHeader: {
      type: Array,
      default: () => []
    },

  },
  data() {
    return {
      listLoading: false,
      finished: false,
      page: 1,
      headerTitle: [
        { header: 'firstClockTime', headerStatus: 'firstClockState', headerRepairState: 'firstRepairState', last: 'lastClockTime', lastStatus: 'lastClockState', lastRepairState: 'lastRepairState' },
        { header: 'amFirstClockTime', headerStatus: 'amFirstClockState', headerRepairState: 'amFirstRepairState', last: 'amLastClockTime', lastStatus: 'amLastClockState', lastRepairState: 'amLastRepairState' },
        { header: 'pmFirstClockTime', headerStatus: 'pmFirstClockState', headerRepairState: 'pmFirstRepairState', last: 'pmLastClockTime', lastStatus: 'pmLastClockState', lastRepairState: 'pmLastRepairState' },
        { header: 'morningFirstClockTime', headerStatus: 'morningFirstClockState', headerRepairState: 'morningFirstRepairState', last: 'morningLastClockTime', lastStatus: 'morningLastClockState', lastRepairState: 'morningLastRepairState' },
        { header: 'nightFirstClockTime', headerStatus: 'nightFirstClockState', headerRepairState: 'nightFirstRepairState', last: 'nightLastClockTime', lastStatus: 'nightLastClockState', lastRepairState: 'nightLastRepairState' }
      ]
    };
  },
  methods: {
    async onLoad() {

      console.log('this.page == this.totalPage',this.page , this.totalPage)
      if (this.page == this.totalPage) {

        this.finished = true
      } else {
        this.page++

        // 分页获取到学生出勤信息
        const res = await this.$https.getStudentDataByPersonTypeAndDateList({
          // classId: this.classId,
          organizationId: this.zhiClass,
          personType: 11,
          type: this.infoItemClass,
          schoolId: this.$store.state.schoolId,
          toDay: this.date,
          pageNum: this.page,
        });

        if (res.code == 200) {
          // 
          console.log(`获取第${this.page}页`, this.tableData )
          this.tableData = [...this.tableData, ...res.data[0]['studentClocksDTOPage'].list]
          this.listLoading = false
        } 
      }

    },
  }
};
</script>

<style lang="scss" scoped>
.list-table-body {
  margin: 0 1rem;
  height: 100%;
  overflow-y: auto;

  .list-table-item {
    border-bottom: 0.06rem solid #f4f4f6;
    padding: 1rem 0;
    align-items: center;

    .table-1 {
      color: #454f63;
      font-size: 0.75rem;
    }

    .table-3 {
      opacity: 0.98;
      color: #78849e;
      font-size: 0.75rem;
      text-align: center;

      .tow-merge-one {
        width: 100%;
        height: 1rem;
        line-height: 1rem;
      }

      .tow-merge-one-line {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 0.5rem 0;

        .tow-merge-one-line-inner {
          width: 0.5px;
          height: 0.5rem;
          background-color: #000;
        }
      }
    }
  }
}

.late {
  color: orange;
}

.early {
  color: rgb(255, 193, 10);
}
</style>
